import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
    API_BASE_URL,
    API_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
    DEFAULT_PER_PAGE,
} from "../../utilities/constants";
import { NavLink, useLocation, useNavigate } from "react-router";
import Pagination from "../../components/ui/Pagination";
import useQueryParams from "../../hooks/useQueryParams";
import { handleApiCall, jsonToQueryParams } from "../../utilities/helper";
import { useUI } from "../../context/UI";
import CustomModal from "../../components/ui/CustomModal";
import ConfirmationModal from "../../components/ui/ConfirmationModal";
import ButtonText from "../../components/ui/button/ButtonText";

const ModulePage = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(false);
    const navigate = useNavigate();
    const { queryParams } = useQueryParams();
    const pageNo = queryParams.get("pageNo") || 0;
    const pageSize = queryParams.get("pageSize") || DEFAULT_PER_PAGE;
    const sortOrder = queryParams.get("sortOrder") || "DESC";
    const location = useLocation();
    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();
    const [controller, setController] = useState(null);
    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const query = jsonToQueryParams({
                search: queryParams.get("search") || "",
            });
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/modules?pageNo=${pageNo}&pageSize=${pageSize}&sortOrder=${sortOrder}&${query}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callListApi();
        setSegmentTitle("Modules");
    }, [location.search]);

    const handleStatusChanges = async (id) => {
        try {
            const response = await handleApiCall(API_URL + `/api/1.0.0/modules/${id}/status/0`, {
                method: "PUT",
            });

            if (response.responseStatus === true) {
                addToastMessage({
                    status: true,
                    message:
                        "You have successfully deleted a Module, Thank You!",
                });
                callListApi();
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully deleted a Module!",
                    status: true,
                    archive: false,
                });
            }
            else {
                addToastMessage({
                    status: false,
                    message: response?.responseDescription ||
                        `Something went wrong while deleting Module. Please try again.`,
                });
            }
        } catch (error) {
            addToastMessage({
                status: false,
                message: `Something went wrong while deleting Module. Please try again.`,
            });
        }
    };

    return (
        <>
            <PageMeta
                title={`Modules - ${DEFAULT_PAGE_TITLE}`}
                description={`Modules - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <div className="space-y-6">
                <div className="flex justify-between items-center mb-4">
                    <PageBreadcrumb pageTitle="Modules" />

                    <ButtonText
                        title='+ Add New'
                        onClick={() => { navigate('/add-modules') }}
                    />
                </div>
            </div>
            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <div className="space-y-6">
                    <div className="relative overflow-x-auto sm:rounded-lg">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 rounded-lg">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        Module Name
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Status
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.records?.map((user, index) => (
                                    <tr key={index} className="border-b dark:border-gray-600 text-sm text-gray-700 dark:text-gray-300">
                                        <td className="px-6 py-4">{user.moduleName || 'NA'}</td>
                                        <td className="px-6 py-4">{user?.statusId === 1
                                            ? "Active"
                                            : user?.statusId === 2
                                                ? "Inactive"
                                                : "-"}</td>
                                        <td className="px-6 py-4 flex gap-5">
                                            <NavLink to={`/edit-modules/${user?.moduleId}`}>
                                                <button
                                                    type="submit"
                                                    className="edit-button"
                                                >
                                                    Edit
                                                </button>
                                            </NavLink>
                                            <div>
                                                <CustomModal
                                                    selector={
                                                        <span>
                                                            <button
                                                                type="button"
                                                                className="bg-red-500 text-white px-6 py-2 rounded-md hover:bg-red-700 transition"
                                                            > Delete</button>

                                                            {/* // variant="delete"
                                                                    //     actionType='delete'
                                                                    //     children='Delete'
                                                                    /> */}
                                                        </span>
                                                    }
                                                    content={
                                                        <ConfirmationModal
                                                            onConfirm={async () => {
                                                                await handleStatusChanges(user?.moduleId);
                                                                return true;
                                                            }}
                                                            message='Are you sure you want to delete this module ?'
                                                        />
                                                    }
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            <div className='flex justify-center items-center'>
                <Pagination
                    currentPage={data?.pageNo + 1} // convert 0-based to 1-based
                    totalElements={data?.totalRecords}
                />
            </div>
        </>
    );
};
export default ModulePage;